<template>
    <q-card
        :inline="inline"
        :class="['card', 'q-ma-sm', {inEdit: inEdit, draggingOver: draggingOver, invalid: invalid}]"
        :style="style"
        ref="card"
        v-if="question">
        <q-card-title class="title">
            <q-field
                :error="$v.question.text.$error"
                error-label="Pole nie może być puste"
            >
                <q-input
                    :readonly="! inEdit"
                    v-model="question.text"
                    float-label="Pytanie"
                    type="text"
                    @input="validate"/>
            </q-field>
        </q-card-title>

        <q-card-main class="main">
            <q-field>
                <q-input
                    :readonly="! inEdit"
                    v-model="question.hint"
                    float-label="Tekst pomocniczy"
                    type="text"
                    @input="validate"/>
            </q-field>

            <q-field
                v-if="inEdit"
                class="q-mb-lg"
                label="Typ odpowiedzi"
                :label-width="12">

                <q-radio v-model="question.method" val="single" @input="validate">Jedna</q-radio>
                <q-radio v-model="question.method" val="many" @input="validate">Wiele</q-radio>
                <q-radio v-model="question.method" val="text" @input="validate">Swobodna</q-radio>
            </q-field>

            <div
                v-for="(answerV, answerIndex) in $v.question.answers.$each.$iter"
                :key="answerV.$model.surveyAnswerId"
                v-if="inEdit && (question.method === 'single' || question.method === 'many')">

                <q-field
                    class="q-mb-lg"
                    :error="answerV.text.$error"
                    error-label="Pole nie może być puste"
                >
                    <div class="row no-wrap">
                        <q-input
                            v-model="answerV.$model.text"
                            type="text"
                            float-label="Odpowiedź"
                            :readonly="!inEdit"
                            @input="validate"
                            @blur="validate"/>

                        <q-btn
                            flat
                            round
                            icon="delete"
                            @click.native="removeQuestion(answerIndex)"
                        >
                            <q-tooltip>
                                Usuń odpowiedź
                            </q-tooltip>
                        </q-btn>

                    </div>
                </q-field>

                <q-field
                    :inline="true"
                    label="Punkty"
                    v-if="survey && survey.qualifying"
                    :error="answerV.points.$error"
                    error-label="Minimalna wartość to 1"
                >
                    <q-input
                        v-model="answerV.$model.points"
                        type="number"
                        :readonly="!inEdit"
                        length="2"
                        @input="validate"
                        />
                </q-field>
            </div>

            <div class="text-right" v-if="inEdit">
                <q-btn
                    v-if="question.method !== 'text'"
                    color="primary"
                    class=""
                    style="font-size: 1.5rem"
                    flat
                    icon="add_circle"
                    @click="createNewAnswer">
                    <q-tooltip>
                        Dodaj odpowiedź
                    </q-tooltip>
                </q-btn>
            </div>

            <q-field v-if="inEdit">
                <q-color
                    float-label="Kolor tła"
                    placeholder="Kolor tła"
                    format-model="hex"
                    v-model="question.backgroundColor" @input="validate"/>
            </q-field>

        </q-card-main>

        <q-card-actions v-if="inEdit" align="end" class="actions"
                        @dragover.native.prevent="dragover"
                        @dragleave.native="dragleave"
                        @dragenter.native="dragenter"
                        @drop.native="dropBackground">
            <q-btn flat round icon="delete" @click.native="remove"/>
        </q-card-actions>
    </q-card>
</template>

<script>
    import QCardTitle from 'quasar-framework/src/components/card/QCardTitle'
    import QCardMedia from 'quasar-framework/src/components/card/QCardMedia'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'
    import QCardActions from 'quasar-framework/src/components/card/QCardActions'
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import QEditor from 'quasar-framework/src/components/editor/QEditor'
    import QField from 'quasar-framework/src/components/field/QField'
    import GenericViewer from './viewers/GenericViewer'
    import QCard from 'quasar-framework/src/components/card/QCard'
    import QChipsInput from 'quasar-framework/src/components/chips-input/QChipsInput'
    import draggable from 'vuedraggable'
    import QToggle from 'quasar-framework/src/components/toggle/QToggle'
    import QInput from 'quasar-framework/src/components/input/QInput'
    import QRadio from 'quasar-framework/src/components/radio/QRadio'
    import QColor from 'quasar-framework/src/components/color/QColor'

    import {required, minValue, minLength, requiredIf} from 'vuelidate/lib/validators'
    import QTooltip from 'quasar-framework/src/components/tooltip/QTooltip'

    export default {
        name: 'SurveyQuestionComponent',
        components: {
            QTooltip,
            QColor,
            QRadio,
            QInput,
            QToggle,
            QChipsInput,
            QCard,
            GenericViewer,
            QField,
            QEditor,
            QBtn,
            QIcon,
            QCardActions,
            QCardMain,
            QCardMedia,
            QCardTitle,
            draggable,
        },
        props: ['model', 'survey', 'editable', 'inEdit', 'inline', 'backgroundUrl', 'backgroundColor'],
        methods: {
            createNewAnswer () {
                const answer = {
                    surveyAnswerId: this.$uuid(),
                    surveyQuestionId: this.question.surveyQuestionId,
                    surveyId: this.question.surveyId,
                    text: 'Odpowiedź...',
                    points: 1,
                    picture: '',
                    movie: '',
                    audio: '',
                    backgroundColor: undefined,
                    backgroundUrl: undefined,
                }

                this.question.answers.push(answer)

                this.validate()
            },
            goToEdit (surveyId) {
                this.$router.push({
                    name: 'survey-edit',
                    params: {surveyId},
                })
            },

            dragenter () {

            },
            dragover () {
                if (this.inEdit) {
                    this.draggingOver = true
                }
            },
            dragleave () {
                if (this.inEdit) {
                    this.draggingOver = false
                }
            },
            dropBackground (e) {
                if (this.inEdit) {
                    try {
                        this.$set(this.model, 'backgroundUrl', JSON.parse(e.dataTransfer.getData('text')).urlPath)
                    } catch (ee) {
                        // ...
                    }
                }
            },
            fetch () {

            },
            removeSurvey () {

            },
            addTextToArticle () {
                this.text = ''
            },
            remove () {
                this.$emit('delete')
            },
            validate () {
                this.$v.$touch()

                this.question.valid = !this.$v.$invalid
                this.$emit('update', this.question)
            },
            removeQuestion (answerIndex) {
                this.question.answers.splice(answerIndex, 1)

                this.validate()
            }
        },
        data () {
            return {
                draggingOver: false,
                isNew: false,
                text: '',
                question: undefined
            }
        },
        mounted () {
            if (this.existingQuestion) {
                this.question = JSON.parse(JSON.stringify(this.existingQuestion))
            }

            this.validate()
        },
        watch: {
            bgr (value) {
                if (value) {
                    this.question.backgroundColor = undefined
                }
            },
            bgrColor (value) {
                if (value) {
                    this.question.backgroundUrl = undefined
                }
            },
            existingQuestion () {
                if (this.existingQuestion) {
                    this.question = JSON.parse(JSON.stringify(this.existingQuestion))
                }
            }
        },
        validations () {
            const qualifying = this.survey && this.survey.qualifying

            return {
                question: {
                    text: {
                        required,
                        minLength: minLength(1)
                    },
                    answers: {
                        required: requiredIf('answersAreRequired'),
                        $each: {
                            points: qualifying ? {
                                required,
                                minValue: minValue(1)
                            } : {},
                            text: {
                                required,
                                minLength: minLength(1)
                            }
                        },
                    },
                    requiredLength (question) {
                        if (question.method !== 'text') {
                            return question.answers.length >= 2
                        }

                        return true
                    }

                }
            }
        },
        computed: {
            invalid () {
                return this.$v.$invalid
            },
            answersAreRequired () {
                return this.question.method !== 'text'
            },
            existingQuestion () {
                return this.model
            },
            bgr () {
                return this.question && this.question.backgroundUrl
            },
            bgrColor () {
                return this.question && this.question.backgroundColor
            },
            style () {
                let value = ''

                if (this.question) {
                    if (this.backgroundUrl || this.backgroundColor) {
                        // from props - higher priority than local model model values
                        if (this.backgroundUrl) {
                            value += `background: url(${this.$store.state.MEDIA_PREFIX_FOR_IMG + this.backgroundUrl}); background-size: cover; `
                        }

                        if (this.backgroundColor) {
                            value += `background-color: ${this.backgroundColor}; `
                        }
                    } else {
                        if (this.question.backgroundUrl) {
                            value += `background: url(${this.$store.state.MEDIA_PREFIX_FOR_IMG + this.question.backgroundUrl}); background-size: cover; `
                        }

                        if (this.question.backgroundColor) {
                            value += `background-color: ${this.question.backgroundColor}; `
                        }
                    }
                }

                return value

            }
        },
    }
</script>

<style scoped lang="scss">
    .card {
        .actions {
            background: gainsboro;
        }
    }

    .invalid {
        border-color: red;
    }

    .card:not(.inEdit) {
        width: 350px;
        /*height: 500px;*/
        overflow: hidden;
        position: relative;

        .media {

        }

        .main {

        }

        .actions {
            display: none;
        }

        &:hover .actions {
            display: flex;
        }
    }

    .card.inEdit {
        width: 350px;
        position: relative;

        .media {

        }

        .main {

        }

        &.draggingOver {
            border: 1px solid red;
        }
    }

    .new-content-area {
        border: 1px dashed gray;
        min-height: 30px;
        line-height: 30px;
        color: gray;
    }

</style>
